module.exports = __webpack_public_path__ + "media/images/countryrect/lb-6ffba6a1660d2f8e6c9c45448c0d826c.svg";